import { render, staticRenderFns } from "./PatientsLayout.vue?vue&type=template&id=1ddc1cbb&scoped=true"
import script from "./PatientsLayout.vue?vue&type=script&lang=js"
export * from "./PatientsLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddc1cbb",
  null
  
)

export default component.exports